import Vue from 'vue'
import Clipboard from 'clipboard'
import $store from '@/store'

function clipboardSuccess() {
  const lang = $store.getters.language
  Vue.prototype.$message({
    message: lang === 'zh' ? '复制成功' : 'Copy successfully',
    type: 'success',
    duration: 1500
  })
}

function clipboardError() {
  const lang = $store.getters.language
  Vue.prototype.$message({
    message: lang === 'zh' ? '复制失败' : 'Copy failed',
    type: 'error'
  })
}

export default function handleClipboard(text, event) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    clipboardSuccess()
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    clipboardError()
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.onClick(event)
}
